/*
  POA favorieten
  Favorietenlijst zonder app. Bewaart kunstwerken (inclusief gekozen kleuren en opties) in de browser van de bezoeker.
  Is de bezoeker bekend bij Klaviyo, dan gaat er een event "Added to Wishlist" naar Klaviyo voor flows.
  Onderdelen:
  - hartje op productkaarten (wordt door dit script op elke product-card geplaatst)
  - productpagina (zoals IKEA en H&M): hartje rechts naast de producttitel, op mobiel en desktop.
    De koopknop blijft de enige grote knop.
  - hartje met teller in de header naast de winkelwagen, opent het favorietenpaneel (ook te openen met #favorieten in de url)
  Werkt in Prestige (Pieces of Art) en Horizon (iTestify).
  Aan bestaande themabestanden is niets veranderd: alles wordt geladen via de sectie 'poa-favorieten'.
*/
(function () {
  if (window.PoaFav) return;

  var KEY = 'poa_favorieten_v1';
  var RESTORE_KEY = 'poa_fav_restore';
  var lang = (document.documentElement.lang || 'nl').slice(0, 2);

  var T = {
    nl: {
      title: 'Je favorieten',
      save: 'Bewaar als favoriet',
      saved: 'Bewaard als favoriet',
      empty: 'Hier verzamel je de kunstwerken die je mooi vindt. Tik op het hartje bij een kunstwerk en het staat hier klaar, met de kleuren die je koos.',
      view: 'Bekijk en bestel',
      remove: 'Verwijder',
      close: 'Sluiten',
      choices: 'Jouw keuzes',
      added: 'Toegevoegd aan je favorieten',
      removed: 'Verwijderd uit je favorieten',
      count: function (n) { return n === 1 ? '1 kunstwerk' : n + ' kunstwerken'; }
    },
    de: {
      title: 'Ihre Merkliste',
      save: 'Auf die Merkliste',
      saved: 'Auf Ihrer Merkliste',
      empty: 'Hier sammeln Sie die Kunstwerke, die Ihnen gefallen. Tippen Sie auf das Herz bei einem Kunstwerk und es steht hier für Sie bereit, mit den Farben, die Sie gewählt haben.',
      view: 'Ansehen und bestellen',
      remove: 'Entfernen',
      close: 'Schliessen',
      choices: 'Ihre Auswahl',
      added: 'Zu Ihrer Merkliste hinzugefügt',
      removed: 'Von Ihrer Merkliste entfernt',
      count: function (n) { return n === 1 ? '1 Kunstwerk' : n + ' Kunstwerke'; }
    },
    en: {
      title: 'Your favourites',
      save: 'Save as favourite',
      saved: 'Saved as favourite',
      empty: 'This is where you collect the artworks you love. Tap the heart on any artwork and it will be waiting here, with the colours you chose.',
      view: 'View and order',
      remove: 'Remove',
      close: 'Close',
      choices: 'Your choices',
      added: 'Added to your favourites',
      removed: 'Removed from your favourites',
      count: function (n) { return n === 1 ? '1 artwork' : n + ' artworks'; }
    }
  };
  var t = T[lang] || T.en;
  // Duitsland gebruikt "Schließen", Zwitserland "Schliessen"
  if (lang === 'de' && window.PoaFavCountry !== 'CH') t.close = 'Schließen';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.4 4.5 6.9 4.5c2.1 0 3.6 1.2 5.1 3 1.5-1.8 3-3 5.1-3 3.5 0 5.5 3.5 4.2 6.8-1.8 4.6-9.3 9.2-9.3 9.2z" fill="var(--poa-fav-fill, none)" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  /* ---------- opslag ---------- */

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    render();
  }
  function keyOf(item) {
    return String(item.handle) + '|' + JSON.stringify(item.groups || {});
  }
  function hasProduct(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }
  function hasExact(item) {
    var k = keyOf(item);
    return read().some(function (i) { return keyOf(i) === k; });
  }

  function add(item) {
    var list = read().filter(function (i) { return keyOf(i) !== keyOf(item); });
    item.at = Date.now();
    list.unshift(item);
    write(list);
    track('Added to Wishlist', item);
    toast(t.added);
  }
  function removeWhere(fn) {
    var removed = read().filter(fn);
    write(read().filter(function (i) { return !fn(i); }));
    removed.forEach(function (i) { track('Removed from Wishlist', i); });
    if (removed.length) toast(t.removed);
  }

  /* ---------- Klaviyo en GA4 ---------- */

  function track(name, item) {
    var props = {
      ProductID: item.id || '',
      ProductHandle: item.handle,
      ProductName: item.title,
      URL: absUrl(item),
      ImageURL: item.img ? (item.img.indexOf('//') === 0 ? 'https:' + item.img : item.img) : '',
      VariantID: item.variant || '',
      Choices: item.labels || {},
      Language: lang,
      WishlistSize: read().length
    };
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', name, props]);
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: name === 'Added to Wishlist' ? 'add_to_wishlist' : 'remove_from_wishlist',
        ecommerce: { items: [{ item_id: String(item.id || item.handle), item_name: item.title, item_variant: item.variant ? String(item.variant) : undefined }] }
      });
    } catch (e) {}
  }

  function absUrl(item) {
    var u = item.url || (root + 'products/' + item.handle);
    if (item.variant) u += (u.indexOf('?') > -1 ? '&' : '?') + 'variant=' + item.variant;
    return location.origin + u;
  }

  /* ---------- productpagina: huidige keuzes uitlezen ---------- */

  function currentConfig(form, productId) {
    var groups = {};
    var labels = {};
    var opts = document.querySelector('poa-options[data-product-id="' + productId + '"]');
    if (opts) {
      opts.querySelectorAll('.poa-options__group').forEach(function (group) {
        var key = group.dataset.group;
        if (!key) return;
        var select = group.querySelector('select');
        var value = '';
        if (select) value = select.value;
        else {
          var checked = group.querySelector('input:checked');
          if (checked) value = checked.value;
        }
        if (!value) return;
        groups[key] = value;
        var legend = group.querySelector('.poa-options__legend > span:first-child');
        var name = legend ? legend.textContent.replace(/:\s*$/, '').trim() : key;
        labels[name] = value;
      });
    }
    var variant = '';
    if (form) {
      try {
        var fd = new FormData(form);
        variant = fd.get('id') || '';
      } catch (e) {}
    }
    if (!variant) {
      var m = location.search.match(/[?&]variant=(\d+)/);
      if (m) variant = m[1];
    }
    if (!variant && form) {
      var hidden = form.querySelector('input[name="id"]');
      if (hidden) variant = hidden.value;
    }
    // Varianttitel (bijv. maat) tonen als die er is
    var p = window.PoaFavProduct;
    if (p && p.variants && variant) {
      var v = p.variants.filter(function (x) { return String(x.id) === String(variant); })[0];
      if (v && v.title && v.title !== 'Default Title') labels[p.variantLabel || 'Variant'] = v.title;
    }
    return { groups: groups, labels: labels, variant: variant ? String(variant) : '' };
  }

  var pdp = null; // { btns, form, p }

  function findProductForm(info, p) {
    var pf = info.querySelector('product-form[data-product-id="' + p.id + '"]') ||
             document.querySelector('product-form[data-product-id="' + p.id + '"]');
    if (pf && pf.querySelector('form')) return pf.querySelector('form');
    return info.querySelector('form[data-type="add-to-cart-form"]') ||
           info.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('form[action*="/cart/add"]');
  }

  // De productfoto: een vaste (niet meescrollende) omlijsting, zodat het hartje blijft staan tijdens het swipen
  function findMediaHost(info) {
    var scope = info.closest('.shopify-section') || document;
    // Een gewoon blok met de foto's erin (geen display: contents), zodat het hartje echt aan de foto vastzit
    var sel = ['.product-gallery__image-list', '.product-information__media', '.product__media-wrapper', '.product-gallery', 'media-gallery'];
    for (var i = 0; i < sel.length; i++) {
      var el = scope.querySelector(sel[i]);
      if (!el || info.contains(el)) continue;
      if (getComputedStyle(el).display === 'contents') continue;
      return el;
    }
    return null;
  }

  // Hartje direct links naast het zoom-icoon in de foto (zelfde hoogte en grootte); geen zoom-icoon: rechtsboven
  function findZoom(host) {
    var list = host.querySelectorAll('[class*="zoom"], [aria-label*="oom"], [data-action*="zoom"]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.classList.contains('poa-fav-pdp')) continue;
      if (!/^(BUTTON|A)$/.test(el.tagName) && !el.closest('button, a')) continue;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.width < 90 && r.height > 0) return el;
    }
    return null;
  }
  // Tweeling van het zoom-icoon: dezelfde plek in de opbouw en dezelfde (sticky) positie, maar één knop naar links.
  // Zo beweegt het hartje precies mee met het zoom-icoon, hoe het thema dat ook neerzet.
  var TWIN_PROPS = ['position', 'top', 'bottom', 'left', 'right', 'gridRowStart', 'gridRowEnd', 'gridColumnStart', 'gridColumnEnd',
    'alignSelf', 'justifySelf', 'zIndex', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'translate', 'transform'];
  function findGalleryZoom(info) {
    var scope = info.closest('.shopify-section') || document;
    return scope.querySelector('.product-gallery__zoom-button');
  }
  function makeZoomTwin(info) {
    var z = findGalleryZoom(info);
    if (!z || !z.parentElement) return null;
    var anchor = z.closest('open-lightbox-button') || z;
    var btn = makePdpButton('poa-fav-pdp--twin');
    anchor.parentElement.insertBefore(btn, anchor);
    styleTwin(btn, z);
    return btn;
  }
  function styleTwin(btn, z) {
    if (!btn.isConnected || !z.isConnected) return;
    var cs = getComputedStyle(z);
    if (cs.display === 'none') return; // desktop: geen zoom-icoon, daar staat het hartje bij de titel
    TWIN_PROPS.forEach(function (k) { btn.style[k] = cs[k]; });
    var w = z.offsetWidth || 36, gap = 8;
    btn.style.width = w + 'px';
    btn.style.height = (z.offsetHeight || w) + 'px';
    if (cs.position === 'absolute' || cs.position === 'fixed') {
      if (cs.right !== 'auto') btn.style.right = (parseFloat(cs.right) + w + gap) + 'px';
      else btn.style.left = (parseFloat(cs.left) - w - gap) + 'px';
    } else {
      // Geen extra ruimte innemen: netto hoogte 0, zodat de foto's niet verschuiven
      var h = z.offsetHeight || w;
      btn.style.marginTop = cs.marginTop;
      btn.style.marginBottom = -(h + (parseFloat(cs.marginTop) || 0)) + 'px';
      btn.style.marginRight = (parseFloat(cs.marginRight) || 0) + w + gap + 'px';
      if (cs.right !== 'auto' && cs.position === 'relative') btn.style.right = cs.right;
    }
    // Controle: staat het hartje echt direct links naast het zoom-icoon? Zo niet, dan de vertaalfout rechtzetten.
    var zr = z.getBoundingClientRect(), br = btn.getBoundingClientRect();
    if (br.width && zr.width) {
      var dx = (zr.left - gap) - br.right, dy = zr.top - br.top;
      if (Math.abs(dx) > 1 || Math.abs(dy) > 1) {
        btn.style.translate = 'none';
        btn.style.transform = 'translate(' + Math.round(dx) + 'px, ' + Math.round(dy) + 'px)';
      }
    }
    if (/poa_fav_debug/.test(location.search)) debugBox({
      mode: 'tweeling naast zoom',
      zoomPos: cs.position + ' top ' + cs.top + ' right ' + cs.right + ' mr ' + cs.marginRight + ' mb ' + cs.marginBottom,
      parentDisplay: getComputedStyle(btn.parentElement).display,
      zoom: [Math.round(zr.top), Math.round(zr.left)].join(','),
      heart: [Math.round(btn.getBoundingClientRect().top), Math.round(btn.getBoundingClientRect().right)].join(','),
      scrollY: Math.round(window.scrollY)
    });
  }
  function placeTwin() {
    if (!pdp || !pdp.twin) return;
    var z = findGalleryZoom(document.querySelector('.product-info') || document.body);
    if (!z) return;
    pdp.twin.style.transform = '';
    styleTwin(pdp.twin, z);
  }
  window.addEventListener('resize', function () { requestAnimationFrame(placeTwin); });
  window.addEventListener('load', placeTwin);

  // Altijd binnen de foto: rechtsboven, of direct links naast het zoom-icoon als dat bovenin de foto staat
  function placeMediaButton() {
    if (!pdp || !pdp.media) return;
    var btn = pdp.media, host = btn.parentElement;
    if (!host || !btn.isConnected) return;
    var img = host.querySelector('.product-gallery__media:not([hidden])') ||
              host.querySelector('.product-gallery__carousel, scroll-carousel, slideshow-component') || host;
    var strip = host.querySelector('.product-gallery__carousel, scroll-carousel, slideshow-component') || img;
    var hr = host.getBoundingClientRect(), ir = img.getBoundingClientRect(), sr = strip.getBoundingClientRect();
    if (!hr.width || !ir.width) return;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var edge = Math.min(Math.max(sr.right, ir.right), vw); // rechterrand van het zichtbare fotogebied
    ir = { top: ir.top, left: ir.left, right: edge };
    var imgTop = ir.top - hr.top;
    var imgRight = hr.right - edge;
    var gap = 14, top = imgTop + gap, right = imgRight + gap, size = 40;

    var z = findZoom(host.closest('.product-gallery, product-gallery, .product-information__media') || host);
    if (z) {
      var zr = z.getBoundingClientRect();
      var inPhotoTop = zr.top >= ir.top - 2 && zr.top <= ir.top + 120 && zr.right <= Math.min(ir.right, vw) + 2 && zr.left >= ir.left;
      size = Math.round(Math.max(zr.width, zr.height)) || size;
      if (inPhotoTop) {
        top = zr.top - hr.top;
        right = hr.right - zr.left + 8;
      } else {
        right = imgRight + gap + size + 8; // ruimte laten voor het zoom-icoon
      }
    }
    btn.style.width = size + 'px';
    btn.style.height = size + 'px';
    btn.style.top = Math.round(top) + 'px';
    btn.style.right = Math.round(right) + 'px';

    // Zelfcorrectie: waar staat het hartje echt op het scherm? Schuif het naar de gewenste plek in de foto.
    var wantTop = hr.top + top, wantRight = hr.right - right;
    var br = btn.getBoundingClientRect();
    var dTop = wantTop - br.top, dRight = br.right - wantRight;
    if (br.width && (Math.abs(dTop) > 1 || Math.abs(dRight) > 1)) {
      btn.style.top = Math.round(top + dTop) + 'px';
      btn.style.right = Math.round(right + dRight) + 'px';
    }
    if (/poa_fav_debug/.test(location.search)) debugBox({
      host: (host.className || host.tagName).toString().slice(0, 60),
      hostPos: getComputedStyle(host).position + '/' + getComputedStyle(host).display,
      offsetParent: btn.offsetParent ? (btn.offsetParent.className || btn.offsetParent.tagName).toString().slice(0, 60) : 'none',
      img: [Math.round(ir.top), Math.round(ir.right)].join(','),
      zoom: z ? [Math.round(z.getBoundingClientRect().top), Math.round(z.getBoundingClientRect().left)].join(',') : 'geen',
      want: [Math.round(wantTop), Math.round(wantRight)].join(','),
      before: [Math.round(br.top), Math.round(br.right)].join(','),
      after: [Math.round(btn.getBoundingClientRect().top), Math.round(btn.getBoundingClientRect().right)].join(','),
      scrollY: Math.round(window.scrollY)
    });
  }
  function debugBox(o) {
    var el = document.getElementById('poa-fav-debug');
    if (!el) {
      el = document.createElement('pre');
      el.id = 'poa-fav-debug';
      el.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483647;background:#111;color:#0f0;font:11px/1.4 monospace;padding:8px;margin:0;max-width:calc(100vw - 16px);white-space:pre-wrap;opacity:.92';
      document.body.appendChild(el);
    }
    el.textContent = Object.keys(o).map(function (k) { return k + ': ' + o[k]; }).join('\n');
  }
  // Ook na scrollen en na het laden van foto's opnieuw controleren
  var placeTimer;
  window.addEventListener('scroll', function () { clearTimeout(placeTimer); placeTimer = setTimeout(placeMediaButton, 150); }, { passive: true });
  window.addEventListener('resize', function () { requestAnimationFrame(placeMediaButton); });
  window.addEventListener('load', placeMediaButton);

  function pdpItem() {
    var c = currentConfig(pdp.form, pdp.p.id);
    var p = pdp.p;
    return { id: p.id, handle: p.handle, title: p.title, img: p.img, url: p.url, variant: c.variant, groups: c.groups, labels: c.labels };
  }
  function pdpConnected() {
    return pdp && pdp.btns.some(function (b) { return b.isConnected; });
  }
  function pdpSync() {
    if (!pdpConnected()) return;
    var on = hasExact(pdpItem());
    pdp.btns.forEach(function (btn) {
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? t.saved : t.save);
      btn.setAttribute('title', on ? t.saved : t.save);
    });
  }
  document.addEventListener('change', function () { setTimeout(pdpSync, 0); });
  document.addEventListener('variant:change', function () { setTimeout(pdpSync, 0); });
  document.addEventListener('variant:update', function () { setTimeout(pdpSync, 50); });
  window.addEventListener('poa-fav:change', pdpSync);

  function makePdpButton(extraClass) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'poa-fav-pdp ' + extraClass;
    btn.innerHTML = HEART;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // geen zoom of lightbox openen in de foto
      var it = pdpItem();
      if (hasExact(it)) removeWhere(function (i) { return keyOf(i) === keyOf(it); });
      else add(it);
    });
    return btn;
  }

  // Gecentreerde titel (mobiel): ruimte aan beide kanten zodat hij in het midden blijft. Links uitgelijnd (desktop): alleen rechts.
  function syncTitleAlign(el) {
    el = el || document.querySelector('.poa-fav-title-text');
    if (!el) return;
    el.classList.toggle('poa-fav-title-text--center', getComputedStyle(el).textAlign === 'center');
  }
  window.addEventListener('resize', function () { requestAnimationFrame(function () { syncTitleAlign(); }); });

  function setupProductPage() {
    var p = window.PoaFavProduct;
    if (!p) return;
    var info = document.querySelector('.product-info') || document.querySelector('.product-details');
    if (!info || document.querySelector('.poa-fav-pdp')) return;
    var btns = [];

    // Desktop: rechts naast de titel
    var titleBtn = makePdpButton('poa-fav-pdp--title');
    var titleBlock = info.querySelector('.product-info__block-item[data-block-type="title"]');
    var titleEl = titleBlock ? titleBlock.querySelector('.product-title') : info.querySelector('h1');
    if (!titleBlock && titleEl) titleBlock = titleEl.parentElement;
    if (titleEl) {
      titleEl.classList.add('poa-fav-title-text');
      syncTitleAlign(titleEl);
    }
    if (titleBlock) {
      titleBlock.classList.add('poa-fav-title');
      titleBlock.appendChild(titleBtn);
    } else {
      info.classList.add('poa-fav-title');
      info.insertBefore(titleBtn, info.firstChild);
    }
    btns.push(titleBtn);

    // Mobiel: als tweeling direct links naast het zoom-icoon (zelfde gedrag), anders rechtsboven in de productfoto
    // Gekozen (21 okt): ook op mobiel alleen het hartje naast de titel. Zet IN_PHOTO op true om het in de foto te tonen.
    var IN_PHOTO = false;
    var twin = IN_PHOTO ? makeZoomTwin(info) : null;
    var media = (IN_PHOTO && !twin) ? findMediaHost(info) : null;
    if (twin) {
      btns.push(twin);
      document.documentElement.classList.add('poa-fav-has-media');
    } else if (media) {
      var mediaBtn = makePdpButton('poa-fav-pdp--media');
      media.classList.add('poa-fav-media-host');
      media.appendChild(mediaBtn);
      btns.push(mediaBtn);
      document.documentElement.classList.add('poa-fav-has-media');
      var mediaRef = mediaBtn;
    } else {
      document.documentElement.classList.remove('poa-fav-has-media');
    }

    pdp = { btns: btns, media: typeof mediaRef !== 'undefined' ? mediaRef : null, twin: twin, form: findProductForm(info, p), p: p };
    pdpSync();
    placeMediaButton();
    [300, 1000, 2500].forEach(function (ms) { setTimeout(function () { placeMediaButton(); placeTwin(); }, ms); }); // na het laden van de foto's
  }

  /* ---------- hartjes op productkaarten ---------- */

  function cardData(card) {
    var link = card.querySelector('a.product-card__media') || card.querySelector('a.product-card__link') || card.querySelector('a[href*="/products/"]');
    var titleEl = card.querySelector('.product-title') || card.querySelector('[ref="productTitleLink"]') || card.querySelector('.product-card__link .visually-hidden');
    var imgEl = card.querySelector('.product-card__image--primary') || card.querySelector('img');
    var img = imgEl ? (imgEl.currentSrc || imgEl.src || '') : '';
    img = img.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    var url = link ? link.getAttribute('href').split('?')[0] : '';
    return {
      handle: cardHandle(card),
      title: titleEl ? titleEl.textContent.trim() : '',
      img: img,
      url: url
    };
  }

  function cardHandle(card) {
    var h = card.getAttribute('handle');
    if (h) return h;
    var a = card.querySelector('a[href*="/products/"]');
    var m = a ? a.getAttribute('href').match(/\/products\/([^/?#]+)/) : null;
    return m ? decodeURIComponent(m[1]) : '';
  }

  function addCardButtons() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.dataset.placeholder === 'true' || !cardHandle(card)) return;
      var fig = card.querySelector('.product-card__figure') || card;
      if (fig.querySelector('.poa-fav-card')) return;
      fig.classList.add('poa-fav-figure');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'poa-fav-card';
      b.innerHTML = HEART;
      fig.appendChild(b);
    });
    syncCardButtons();
  }

  function syncCardButtons() {
    document.querySelectorAll('.poa-fav-card').forEach(function (b) {
      var card = b.closest('product-card');
      var on = card ? hasProduct(cardHandle(card)) : false;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? t.saved : t.save);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.poa-fav-card');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var card = b.closest('product-card');
    if (!card) return;
    var d = cardData(card);
    if (hasProduct(d.handle)) removeWhere(function (i) { return i.handle === d.handle; });
    else add({ id: '', handle: d.handle, title: d.title, img: d.img, url: d.url, variant: '', groups: {}, labels: {} });
  }, true);

  /* ---------- header-teller ---------- */

  function addHeaderIcon() {
    var nav = document.querySelector('.header__secondary-nav') || document.querySelector('header-actions');
    if (!nav || nav.querySelector('.poa-fav-header')) return;
    var cart = nav.querySelector(':scope > cart-drawer-component') || nav.querySelector(':scope > a[href*="/cart"]') || nav.querySelector('a[href*="/cart"]');
    if (cart && cart.parentElement !== nav) cart = null;
    // Een knop, geen link: een link met # laat het thema naar boven springen
    var a = document.createElement('button');
    a.type = 'button';
    a.className = 'poa-fav-header';
    a.setAttribute('data-poa-fav-open', '');
    a.setAttribute('aria-label', t.title);
    a.innerHTML = HEART.replace('class=""', '') + '<span class="poa-fav-header__count" data-poa-fav-count hidden>0</span>';
    if (cart) nav.insertBefore(a, cart); else nav.appendChild(a);
  }

  function syncHeader() {
    var n = read().length;
    document.querySelectorAll('[data-poa-fav-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-poa-fav-open]').forEach(function (el) {
      el.classList.toggle('is-on', n > 0);
    });
  }

  /* ---------- paneel ---------- */

  var panel;
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function buildPanel() {
    panel = document.createElement('div');
    panel.className = 'poa-fav-panel';
    panel.hidden = true;
    panel.innerHTML =
      '<div class="poa-fav-panel__overlay" data-poa-fav-close></div>' +
      '<aside class="poa-fav-panel__box" role="dialog" aria-modal="true" aria-labelledby="poa-fav-title">' +
        '<header class="poa-fav-panel__head">' +
          '<div><p id="poa-fav-title" class="h5">' + esc(t.title) + '</p><p class="poa-fav-panel__count text-subdued"></p></div>' +
          '<button type="button" class="poa-fav-panel__close" data-poa-fav-close aria-label="' + esc(t.close) + '">' +
            '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="poa-fav-panel__body"></div>' +
      '</aside>';
    document.body.appendChild(panel);
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-poa-fav-close]')) { close(); return; }
      var rm = e.target.closest('[data-poa-fav-remove]');
      if (rm) {
        var k = rm.getAttribute('data-poa-fav-remove');
        removeWhere(function (i) { return keyOf(i) === k; });
        return;
      }
      var view = e.target.closest('[data-poa-fav-view]');
      if (view) {
        var key = view.getAttribute('data-poa-fav-view');
        var it = read().filter(function (i) { return keyOf(i) === key; })[0];
        if (it && it.groups && Object.keys(it.groups).length) {
          try { sessionStorage.setItem(RESTORE_KEY, JSON.stringify({ id: it.id, groups: it.groups })); } catch (err) {}
        }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && !panel.hidden) close();
    });
  }

  function renderPanel() {
    if (!panel) return;
    var list = read();
    panel.querySelector('.poa-fav-panel__count').textContent = list.length ? t.count(list.length) : '';
    var body = panel.querySelector('.poa-fav-panel__body');
    if (!list.length) {
      body.innerHTML = '<p class="poa-fav-panel__empty">' + esc(t.empty) + '</p>';
      return;
    }
    body.innerHTML = '<ul class="poa-fav-list">' + list.map(function (i) {
      var k = keyOf(i);
      var href = (i.url || root + 'products/' + i.handle) + (i.variant ? '?variant=' + i.variant : '');
      var choices = Object.keys(i.labels || {}).map(function (name) {
        return '<li><span>' + esc(name) + ':</span> ' + esc(i.labels[name]) + '</li>';
      }).join('');
      return '<li class="poa-fav-item" data-handle="' + esc(i.handle) + '">' +
        '<a class="poa-fav-item__img" href="' + esc(href) + '" data-poa-fav-view="' + esc(k) + '">' +
          (i.img ? '<img src="' + esc(imgUrl(i.img, 240)) + '" alt="" width="96" height="96" loading="lazy">' : '') +
        '</a>' +
        '<div class="poa-fav-item__info">' +
          '<a class="poa-fav-item__title" href="' + esc(href) + '" data-poa-fav-view="' + esc(k) + '">' + esc(i.title) + '</a>' +
          (choices ? '<ul class="poa-fav-item__choices">' + choices + '</ul>' : '') +
          '<div class="poa-fav-item__actions">' +
            '<a class="poa-fav-item__view" href="' + esc(href) + '" data-poa-fav-view="' + esc(k) + '">' + esc(t.view) + '</a>' +
            '<button type="button" class="poa-fav-item__remove" data-poa-fav-remove="' + esc(k) + '">' + esc(t.remove) + '</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('') + '</ul>';
    refreshTitles(list);
  }

  // Titels ophalen in de taal van de bezoeker (handig als iemand wisselt van taal)
  var fetched = {};
  function refreshTitles(list) {
    list.forEach(function (i) {
      if (!i.handle || fetched[i.handle]) return;
      fetched[i.handle] = true;
      fetch(root + 'products/' + encodeURIComponent(i.handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var all = read();
          var changed = false;
          all.forEach(function (x) {
            if (x.handle === i.handle) {
              if (p.title && x.title !== p.title) { x.title = p.title; changed = true; }
              if (p.url && x.url !== p.url) { x.url = p.url; changed = true; }
            }
          });
          if (changed) write(all);
        })
        .catch(function () {});
    });
  }

  var lastFocus, savedScroll = 0;
  function focusNoScroll(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function open() {
    if (!panel) buildPanel();
    renderPanel();
    lastFocus = document.activeElement;
    savedScroll = window.scrollY || window.pageYOffset || 0;
    panel.hidden = false;
    document.documentElement.classList.add('poa-fav-lock');
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    focusNoScroll(panel.querySelector('.poa-fav-panel__close'));
  }
  function close() {
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('poa-fav-lock');
    // Terug naar precies dezelfde plek op de pagina
    if (Math.abs((window.scrollY || 0) - savedScroll) > 2) window.scrollTo(0, savedScroll);
    setTimeout(function () { panel.hidden = true; }, 250);
    if (location.hash === '#favorieten') history.replaceState(null, '', location.pathname + location.search);
    focusNoScroll(lastFocus);
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-poa-fav-open]');
    if (!o) return;
    e.preventDefault();
    open();
  });
  window.addEventListener('hashchange', function () { if (location.hash === '#favorieten') open(); });

  /* ---------- melding ---------- */

  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'poa-fav-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = HEART + '<span>' + esc(msg) + '</span>';
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }

  /* ---------- alles bijwerken ---------- */

  function render() {
    syncHeader();
    syncCardButtons();
    if (panel && !panel.hidden) renderPanel();
    window.dispatchEvent(new CustomEvent('poa-fav:change'));
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });

  // Nieuwe productkaarten (filteren, laden van meer producten) ook bijwerken
  var mo = new MutationObserver(function (muts) {
    for (var m = 0; m < muts.length; m++) {
      var nodes = muts[m].addedNodes;
      for (var n = 0; n < nodes.length; n++) {
        var node = nodes[n];
        if (node.nodeType === 1 && (node.matches('product-card') || node.querySelector('product-card'))) { addCardButtons(); }
        if (node.nodeType === 1 && window.PoaFavProduct && !document.querySelector('.poa-fav-pdp')) { setupProductPage(); }
        if (node.nodeType === 1 && pdp && !pdp.btns.every(function (b) { return b.isConnected; })) {
          pdp.btns.forEach(function (b) { if (b.isConnected) b.remove(); });
          pdp = null; setupProductPage();
        }
      }
    }
  });

  function init() {
    addHeaderIcon();
    syncHeader();
    addCardButtons();
    setupProductPage();
    mo.observe(document.body, { childList: true, subtree: true });
    if (location.hash === '#favorieten') open();
  }

  window.PoaFav = { open: open, close: close, list: read, add: add };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
